<template>
  <div>
    <b-container fluid>
      <b-row class="page-content">
        <b-col cols="12">
          <keywords-table/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import KeywordsTable from '../components/keywords/KeywordsTable.vue';

  export default {
    components: {
      KeywordsTable,
    },
  };
</script>

<style scoped>

</style>
